export default __webpack_public_path__ + "static/media/1804.d5669913.png";